import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TWButton } from '../../../../components/ui';

// ConnectSupport calls useAccountSession and useConnectInstance itself, and a
// component cannot catch an error thrown by its own render — a boundary
// defined inside ConnectSupport's own return statement never even gets built
// if either hook throws before that return runs. This has to live one level
// up, at ConnectSupport's mount site (connect-tab.js), wrapping the whole
// component rather than markup inside it — the same fix account-sections.js
// applies on the settings surface, and the finance surface already applied
// with connect-panel-boundary.js. Its own small component, not either of
// those: this sits in the company-detail tabs, in the tab's own idiom (an h3
// section, matching every sibling section on this tab), and never imports
// the finance module's copy.
const ConnectSupportBoundary = ({ retryLabel = 'Retry', children }) => (
  <ErrorBoundary
    fallbackRender={() => (
      <section className="py-6">
        <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100">
          Support
        </h3>
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-slate-500 dark:text-slate-400">
            This section could not load. Refresh the page to try again.
          </p>
          <TWButton
            size="sm"
            label={retryLabel}
            onClick={() => window.location.reload()}
            aria-label={retryLabel + ' support'}
          />
        </div>
      </section>
    )}
  >
    {children}
  </ErrorBoundary>
);

export default ConnectSupportBoundary;
